export const noInput = {
    backgroundColor: 'transparent',
    display: 'inline',
    width: '35%',
    fontWeight: 'bold',
    border: 'none'
}

